const uniq = <T extends string | number>(arr: T[], onlyTruthy?: boolean) => {
    const values = [...new Set(arr)];
    return onlyTruthy ? values.filter(Boolean) : values;
};

export default uniq;
